import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { getEmployeeBO } from './dashboard.model';
@Injectable({
    providedIn: 'root'
})
export class ClientzipcodeService extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
        super();
    }
    public outputValuesClientzipcode(U: getEmployeeBO): void {
        this.GetClientzipcodeList(U).subscribe(x => super.next(x));
    }
    GetClientzipcodeList(U?: getEmployeeBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/Client/GetClientzipcodeList", U)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['clientLst'],
                        count: response['totalCount']
                    }
            ))
    }
}
